export const FOOTER_LINKS_SECTIONS = [
  {
    text: 'O nás',
    location: 'https://www.economia.cz/project/o-nas'
  },
  {
    text: 'Všechny služby',
    location: '/sluzby/'
  },
  {
    text: 'Volná místa',
    location: 'http://economia.jobs.cz/'
  },
  {
    text: 'Služby firmám',
    location: '/agentura-najisto/'
  },
  {
    text: 'Všeobecné podmínky',
    location: 'https://economia.cz/smluvni-podminky-sluzby-centrum-cz-e-mail/'
  },
  {
    text: 'Cookies',
    location: 'https://economia.cz/prohlaseni-o-cookies/'
  },
  {
    text: 'Ochrana osobních údajů',
    location: 'https://economia.cz/ochrana-osobnich-udaju/'
  },
  {
    text: 'Zpracování osobních údajů',
    location: 'https://economia.cz/zpracovani-osobnich-udaju/'
  },
  {
    text: 'Nápověda',
    location: 'http://napoveda.centrum.cz/'
  }
]

export const FOOTER_LINKS_SITES = [
  {
    text: 'Centrum.cz',
    location: 'https://www.centrum.cz/'
  },
  {
    text: 'Atlas.cz',
    location: 'https://atlas.centrum.cz/'
  },
  {
    text: 'Volny.cz',
    location: 'https://www.volny.cz/'
  }
]
